exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationDisplay__name___2mxDM {\n\tcolor: #000;\n\tfont-weight: 300;\n}\n", ""]);

// exports
exports.locals = {
	"name": "notificationDisplay__name___2mxDM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/utilities/Data/Notification/notificationDisplay.icss
// module id = 1454
// module chunks = 0